import RegEx from '../../../utils/FormUtils/RegEx';

const breakCamelCase = (str: string): string => {
  return str.replace(RegEx.breakCamelCase, '$1 $2');
};

export default breakCamelCase;


export const breakCamelCaseWithNumbers = (str: string): string => {
  return str
    .replace(RegEx.breakCamelCase, '$1 $2') // lowercase to uppercase
    .replace(/([a-zA-Z])([0-9])/g, '$1 $2') // letter to number
    .replace(/([0-9])([a-zA-Z])/g, '$1 $2'); // number to letter
};
